/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'paneFollowupUserWorkflowId';
const QS_TYPE: QueryStateSchema['type'] = 'followupHistory';

export const useOpenFollowupPane = (): ((args: { followupUserWorkflowId: string }) => void) => {
  const [followupUserWorkflowIdDeprecated, setFollowupUserWorkflowId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (followupUserWorkflowIdDeprecated) {
      setFollowupUserWorkflowId(null);
      setState(backwardsCompatabilityFactory({ id: followupUserWorkflowIdDeprecated, type: QS_TYPE }));
    }
  }, [followupUserWorkflowIdDeprecated]);

  return ({ followupUserWorkflowId }) => {
    setState(prevState => [...(prevState || []), {
      id: followupUserWorkflowId,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};
